import { render, staticRenderFns } from "./ElementSourceTableColumn.vue?vue&type=template&id=65d3a3a6&scoped=true"
import script from "./ElementSourceTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementSourceTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementSourceTableColumn.vue?vue&type=style&index=0&id=65d3a3a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d3a3a6",
  null
  
)

export default component.exports